import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'web-library';

interface TaskListUserTabProps {
  selectedTab: number;
  setSelectedTab: React.Dispatch<React.SetStateAction<number>>;
  onChangeTab: (event: any, newValue: any) => void;
}

const TaskListUserTab = ({ selectedTab, setSelectedTab, onChangeTab }: TaskListUserTabProps) => {
  const { t } = useTranslation();

  return (
    <Tabs
      value={selectedTab}
      indicatorColor="primary"
      textColor="primary"
      onChange={onChangeTab}
      ariaLabel="status tabs"
      // @ts-ignore
      tabs={[t('admin->>TaskListUserTab.Pending'), t('admin->>TaskListUserTab.Archived')]}
    />
  );
};

export default TaskListUserTab;
